import { bookingVerticalType, bookingVerticalFromSignupVertical } from 'us-web-services';

// Re-exported from us-web-services so that services/admin code and React
// component code share a single source of truth for vertical-type ids.
export { bookingVerticalType, bookingVerticalFromSignupVertical };

export const availabilityTypeConstant = [
  {
    id: undefined,
    type: 'All',
    code: 'ALL',
  },
  {
    id: 1,
    type: 'Part Time',
    code: 'PART_TIME',
    label: 'Part time',
  },
  {
    id: 2,
    type: 'Full Time',
    code: 'FULL_TIME',
    label: 'Full time',
  },
  {
    id: 3,
    type: 'Occasional',
    code: 'OCCASIONAL',
  },
];

export const bookingTypeConstant = [
  {
    id: bookingVerticalType.CHILD_CARE,
    code: 'childCare',
    label: 'Child care',
  },
  {
    id: bookingVerticalType.PET_CARE,
    code: 'petCare',
    label: 'Pet care',
  },
  {
    id: bookingVerticalType.SENIOR_CARE,
    code: 'seniorCare',
    label: 'Senior care',
  },
  {
    id: bookingVerticalType.HOUSEHOLD_SERVICES,
    code: 'householdServices',
    label: 'Household services',
  }
];

export const jobTypeConstant = {
  ONE_TIME: 'one_time',
  RECURRING: 'recurring',
};
